export enum RolesEnum {
  TECHNICAL_ADMIN = 'TECHNICAL_ADMIN',
  ORGANIZATION = 'ORGANIZATION',
  CLIENT_ADMIN = 'CLIENT_ADMIN',
  CLIENT_USER = 'CLIENT_USER',
  CONTRACTOR = 'CONTRACTOR',
  REGIONAL_ADMIN = 'REGIONAL_ADMIN', // at the moment, used only in combination with CLIENT_ADMIN
}
